import React from 'react';
import { StyleSheet, View } from 'react-native';
import { rem } from 'design-system/values';
import RowAccount from 'features/accounts/components/RowAccount';
const AccountsList = ({ accounts }) => (<>
    {accounts.map((account) => (<View key={account.id} style={styles.accountNameContainer}>
        <RowAccount hideSpaceUserAvatar data={account} small hideLogo style={styles.row} disabled hideActionRequiredText/>
      </View>))}
  </>);
const styles = StyleSheet.create({
    accountNameContainer: {
        paddingHorizontal: rem(16),
    },
    row: {
        paddingTop: rem(8),
        paddingBottom: rem(8),
    },
});
export default AccountsList;
